module.exports = __webpack_public_path__ + "img/banner02.a257b159.png";